import { Trans } from '~/common/context';
import { QuoteTable } from '~/purchase/components';
import { Text } from '@wyz/ui';

function QuoteTableHeader({ pointOfSaleView }: { pointOfSaleView: boolean }) {
  return (
    <QuoteTable pointOfSaleView={pointOfSaleView}>
      <thead className='align-middle'>
        <tr>
          <th className='px-2 text-center' id='product'>
            <Trans i18nKey='app.purchase.table.product' />
          </th>
          <th className='px-2 text-center' id='description'>
            <Trans i18nKey='app.common.description' />
          </th>
          <th className='px-2 text-center' id='bf'>
            <Trans i18nKey='app.common.price.bf' />
          </th>
          {pointOfSaleView && (
            <th className='px-2 text-center' id='supplier'>
              <Trans i18nKey='app.purchase.table.supplier' />
            </th>
          )}
          <th className='px-2 text-center' id='delivery'>
            <Trans i18nKey='app.common.estimation_delivery' />
          </th>

          {pointOfSaleView ? (
            <>
              <th className='px-2 text-center' id='stock'>
                <Trans i18nKey='app.common.quantity' />
              </th>
              <th className='px-2 text-center' id='margin'>
                <Trans i18nKey='app.purchase.quote_search_page.table.net_price' />
                <br />
                <Text color='info' weight='bold' heading='xxs'>
                  <Trans i18nKey='app.purchase.quote_search_page.table.net_margin' />
                </Text>
              </th>
              <th className='px-2 text-center' id='selection'>
                <Trans i18nKey='app.purchase.quote_search_page.table.quantity_and_price' />
              </th>
            </>
          ) : (
            <th className='px-2 text-center' id='selection'>
              <Trans i18nKey='app.common.unit_price_without_tax' />
            </th>
          )}

          <th className='px-2 text-center' id='action'>
            <Trans i18nKey='app.common.actions' />
          </th>
        </tr>
      </thead>
    </QuoteTable>
  );
}

export default QuoteTableHeader;
